export default {
  registrations: {
    nl: 'Registraties',
    en: 'Registrations',
    de: 'Registrations'
  }
}
